// import React, { useState, useEffect, useRef } from "react";
// import { Sidebar } from "@/components/Sidebar";
// import { Button } from "@/components/ui/button";
// import { Card, CardContent } from "@/components/ui/card";
// import { Input } from "@/components/ui/input";
// import { Badge } from "@/components/ui/badge";
// import { useNavigate } from "react-router-dom";
// import { Upload } from "lucide-react";
// import { ArrowLeft } from "lucide-react";
// import { endpoints } from "@/config/apiEndpoints";
// import axiosInstance from "@/config/axiosInstance";
// import { useToast } from "@/hooks/use-toast";
// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
//   DialogClose,
// } from "@/components/ui/dialog";
// import {
//   Search,
//   Filter,
//   Eye,
//   Copy,
//   Star,
//   Grid3X3,
//   List,
//   Layout,
// } from "lucide-react";
// import { Link } from "react-router-dom";
// import Template1 from "@/components/templates/Template1";
// import Template2 from "@/components/templates/Template2";
// import Template3 from "@/components/templates/Template3";
// import Template4 from "@/components/templates/Template4";
// import Template5 from "@/components/templates/Template5";
// import Template6 from "@/components/templates/Template6";
// import Template7 from "@/components/templates/Template7";
// import Template8 from "@/components/templates/Template8";
// interface Property {
//   id: string;
//   title: string;
//   address: string;
//   price: string | number;
//   bedrooms: number;
//   bathrooms: number;
//   area: number;
//   property_type: string;
//   status: string;
// }

// const TemplateGallery = () => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedFilter, setSelectedFilter] = useState("all");

//   const [properties, setProperties] = useState<Property[]>([]);
//   const [loadingProperties, setLoadingProperties] = useState(false);
//   const { toast } = useToast();
//   const [showPropertyPopup, setShowPropertyPopup] = useState(false);
//   const [popupTemplate, setPopupTemplate] = useState<any>(null);

//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const navigate = useNavigate();
//   const previewFileInputRef = useRef<HTMLInputElement>(null);
//   const handleTemplateSelect = (template) => {
//     setPopupTemplate(template);
//     setShowPropertyPopup(true);
//   };

//   const templateComponents = {
//     1: Template1,
//     2: Template2,
//     3: Template3,
//     4: Template4,
//     5: Template5,
//     6: Template6,
//     7: Template7,
//     8: Template8,
//   };

//   const templates = [
//     {
//       id: 1,
//       name: "Template 1",
//       category: "Modern Hero Layout",
//       style: "Clean & Professional",
//       component: Template1,
//       rating: 4.8,
//       uses: 1247,
//       tag: "Just Listed",
//       description:
//         "Large hero image with prominent pricing and clean property details",
//     },
//     {
//       id: 2,
//       name: "Template 2",
//       category: "Luxury Showcase",
//       style: "Premium & Elegant",
//       component: Template2,
//       rating: 4.9,
//       uses: 982,
//       tag: "Priced to Sell",
//       description: "Sophisticated layout perfect for high-end properties",
//     },
//     {
//       id: 3,
//       name: "Template 3",
//       category: "Gallery Focus",
//       style: "Image-Driven",
//       component: Template3,
//       rating: 4.7,
//       uses: 756,
//       tag: "Open House",
//       description:
//         "Multiple property images with integrated feature highlights",
//     },
//     {
//       id: 4,
//       name: "Template 4",
//       category: "Traditional Layout",
//       style: "Classic & Trustworthy",
//       component: Template4,
//       rating: 4.6,
//       uses: 634,
//       tag: "Seller Motivated",
//       description:
//         "Professional format with comprehensive property information",
//     },
//     {
//       id: 5,
//       name: "Template 5",
//       category: "Split Screen",
//       style: "Modern Balance",
//       component: Template5,
//       rating: 4.8,
//       uses: 523,
//       tag: "Just Listed",
//       description: "Balanced layout with image and details side-by-side",
//     },
//     {
//       id: 6,
//       name: "Template 6",
//       category: "Feature-Rich",
//       style: "Comprehensive Info",
//       component: Template6,
//       rating: 4.9,
//       uses: 445,
//       tag: "Priced to Sell",
//       description: "Detailed property features with agent spotlight section",
//     },
//     {
//       id: 7,
//       name: "Template 7",
//       category: "Bold Impact",
//       style: "Eye-Catching",
//       component: Template7,
//       rating: 4.7,
//       uses: 378,
//       tag: "Open House",
//       description:
//         "Dynamic design with strong visual hierarchy and call-to-action",
//     },
//     {
//       id: 8,
//       name: "Template 8",
//       category: "Minimalist Pro",
//       style: "Simple & Effective",
//       component: Template8,
//       rating: 4.8,
//       uses: 298,
//       tag: "Seller Motivated",
//       description:
//         "Clean, focused design highlighting key property selling points",
//     },
//   ];

//   const filters = [
//     { id: "all", label: "All Templates" },
//     { id: "modern", label: "Modern" },
//     { id: "luxury", label: "Luxury" },
//     { id: "traditional", label: "Traditional" },
//     { id: "gallery", label: "Gallery Focus" },
//   ];

//   const filteredTemplates = templates.filter((template) => {
//     const matchesSearch =
//       template.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       template.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       template.style.toLowerCase().includes(searchQuery.toLowerCase());
//     const matchesFilter =
//       selectedFilter === "all" ||
//       template.category.toLowerCase().includes(selectedFilter) ||
//       template.style.toLowerCase().includes(selectedFilter);
//     return matchesSearch && matchesFilter;
//   });

//   useEffect(() => {
//     if (showPropertyPopup) {
//       const fetchProperties = async () => {
//         try {
//           setLoadingProperties(true);
//           const res = await axiosInstance.get(endpoints.properties);
//           const sorted = [...res.data].sort((a: any, b: any) => {
//             const dateA = new Date(a.created_at || a.id).getTime();
//             const dateB = new Date(b.created_at || b.id).getTime();
//             return dateB - dateA;
//           });
//           setProperties(sorted);
//         } catch (error) {
//           toast({
//             title: "Error",
//             description: "Failed to load properties",
//             variant: "destructive",
//           });
//         } finally {
//           setLoadingProperties(false);
//         }
//       };
//       fetchProperties();
//     }
//   }, [showPropertyPopup, toast]);

//   return (
//     <div className="flex min-h-screen bg-background">
//       <Sidebar />

//       <main className="flex-1 p-8">
//         <div className="max-w-7xl mx-auto">
//           {/* Header */}
//           <div className="mb-8">
//             <div className="flex justify-between items-center mb-6">
//               <div>
//                 <h1 className="text-3xl font-bold text-primary">
//                   Real Estate Email Flyer Templates
//                 </h1>
//                 <p className="text-muted-foreground mt-1">
//                   Professional, data-driven email flyer templates for property
//                   marketing campaigns. Each template auto-fills with your
//                   property data and is fully customizable.
//                 </p>
//               </div>
//               <Button asChild variant="cta" size="lg">
//                 <Link to="/template-builder">
//                   <Layout className="mr-2 h-4 w-4" />
//                   Create Custom Template
//                 </Link>
//               </Button>
//             </div>

//             {/* Search and Filters */}
//             <div className="flex flex-col sm:flex-row gap-4 items-center">
//               <div className="relative flex-1 max-w-md">
//                 <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
//                 <Input
//                   placeholder="Search templates..."
//                   className="pl-10"
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                 />
//               </div>

//               <div className="flex flex-wrap gap-2">
//                 {filters.map((filter) => (
//                   <Button
//                     key={filter.id}
//                     variant={selectedFilter === filter.id ? "cta" : "outline"}
//                     size="sm"
//                     onClick={() => setSelectedFilter(filter.id)}
//                   >
//                     {filter.label}
//                   </Button>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Template Grid */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {filteredTemplates.map((template) => {
//               const TemplateComponent = template.component;
//               return (
//                 // <Card key={template.id} className="group cursor-pointer transition-smooth hover:shadow-elevated bg-gradient-card">
//                 //   <CardContent className="p-0">
//                 //     <div className="relative overflow-hidden rounded-t-lg">
//                 //       <div className="w-full h-48 overflow-hidden bg-white relative">
//                 //         <div className="scale-[0.25] origin-top-left w-[400%] h-[400%] pointer-events-none">
//                 //           <TemplateComponent
//                 //             data={{
//                 //               heroImage: 'path_to_image.jpg',
//                 //               propertyName: 'Sample Property',
//                 //               price: '$1,000,000',
//                 //               address: '123 Main St, City, Country',
//                 //               features: ['Pool', 'Garage', 'Garden'],
//                 //             }}
//                 //             selectedList={[]}
//                 //             fileInputRef={null}
//                 //             onInputChange={() => {}}
//                 //             onFileChange={() => {}}
//                 //             onAddFeature={() => {}}
//                 //             onFeatureChange={() => {}}
//                 //             onFeatureBlur={() => {}}
//                 //             onFeatureDelete={() => {}}
//                 //             onListChange={() => {}}
//                 //             propertyLists={[]}
//                 //           />
//                 //         </div>
//                 //       </div>
//                 //       {/* Template Preview Actions */}
//                 //       <div className="absolute inset-0 bg-primary/20 opacity-0 group-hover:opacity-100 transition-smooth flex items-center justify-center">
//                 //         <div className="flex space-x-2">
//                 //           <Button size="sm" variant="cta" asChild>
//                 //             <Link to={`/template-preview/${template.id}`}>
//                 //               <Eye className="mr-2 h-4 w-4" />
//                 //               Preview
//                 //             </Link>
//                 //           </Button>
//                 //           <Button size="sm" variant="professional" asChild>
//                 //             <Link to={`Template${template.id}`}>
//                 //               <Copy className="mr-2 h-4 w-4" />
//                 //               Use Template
//                 //             </Link>
//                 //           </Button>
//                 //         </div>
//                 //       </div>
//                 //     </div>

//                 //     <div className="p-4">
//                 //       <div className="flex justify-between items-start mb-2">
//                 //         <h3 className="font-semibold text-primary group-hover:text-cta transition-smooth">
//                 //           {template.name}
//                 //         </h3>
//                 //         <div className="flex items-center">
//                 //           <Star className="h-4 w-4 fill-current text-yellow-400 mr-1" />
//                 //           <span className="text-sm text-muted-foreground">{template.rating}</span>
//                 //         </div>
//                 //       </div>

//                 //       <div className="flex justify-between items-center">
//                 //         <div className="flex space-x-2">
//                 //           <Badge variant="secondary">{template.category}</Badge>
//                 //           <Badge variant="outline">{template.style}</Badge>
//                 //         </div>
//                 //         <span className="text-xs text-muted-foreground">
//                 //           {template.uses.toLocaleString()} uses
//                 //         </span>
//                 //       </div>
//                 //     </div>
//                 //   </CardContent>
//                 // </Card>
//                 <Card
//                   key={template.id}
//                   className="group cursor-pointer transition-smooth hover:shadow-elevated bg-gradient-card"
//                 >
//                   <CardContent className="p-0">
//                     <div className="relative overflow-hidden rounded-t-lg">
//                       <div className="w-full h-48 overflow-hidden bg-white relative">
//                         <div className="scale-[0.25] origin-top-left w-[400%] h-[400%] pointer-events-none">
//                           <TemplateComponent
//                             view={TemplateComponent as any}
//                             data={{
//                               heroImage: "path_to_image.jpg",
//                               headline: "Sample Property",
//                               price: 1000000,
//                               address: "123 Main St, City, Country",
//                               bedrooms: 3,
//                               bathrooms: 2,
//                               area: 2000,
//                               description:
//                                 "Beautiful property with modern amenities",
//                               text_section: "",
//                               list_name: "",
//                               // FIXED: features as objects
//                               features: [
//                                 { feature_name: "Pool" },
//                                 { feature_name: "Garage" },
//                                 { feature_name: "Garden" },
//                               ],
//                             }}
//                             selectedList={""}
//                             fileInputRef={previewFileInputRef} // Instead of null
//                             onInputChange={() => {}}
//                             onFileChange={async () => {}}
//                             onAddFeature={() => {}}
//                             onFeatureChange={() => {}}
//                             onFeatureBlur={() => {}}
//                             onFeatureDelete={() => {}}
//                             onListChange={async () => {}}
//                             propertyLists={[]}
//                           />
//                         </div>
//                       </div>

//                       {/* Hover Actions */}
//                       <div className="absolute inset-0 bg-primary/20 opacity-0 group-hover:opacity-100 transition-smooth flex items-center justify-center">
//                         <div className="flex space-x-2">
//                           {/* <Button size="sm" variant="cta" asChild>
//                             <Link to={`/template-preview/${template.id}`}>
//                               <Eye className="mr-2 h-4 w-4" />
//                               Preview
//                             </Link>
//                           </Button> */}

//                           <Button
//                             size="sm"
//                             variant="professional"
//                             onClick={() => handleTemplateSelect(template)} // Changed to open popup
//                           >
//                             <Copy className="mr-2 h-4 w-4" />
//                             Use Template
//                           </Button>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Template Info */}
//                     <div className="p-4">
//                       <div className="flex justify-between items-start mb-2">
//                         <h3 className="font-semibold text-primary group-hover:text-cta transition-smooth">
//                           {template.name}
//                         </h3>
//                         <div className="flex items-center">
//                           <Star className="h-4 w-4 fill-current text-yellow-400 mr-1" />
//                           <span className="text-sm text-muted-foreground">
//                             {template.rating}
//                           </span>
//                         </div>
//                       </div>

//                       <div className="flex justify-between items-center">
//                         <div className="flex space-x-2">
//                           <Badge variant="secondary">{template.category}</Badge>
//                           <Badge variant="outline">{template.style}</Badge>
//                         </div>
//                         <span className="text-xs text-muted-foreground">
//                           {template.uses.toLocaleString()} uses
//                         </span>
//                       </div>
//                     </div>
//                   </CardContent>
//                 </Card>
//               );
//             })}
//           </div>

//           {showPropertyPopup && popupTemplate && (
//             <Dialog
//               open={showPropertyPopup}
//               onOpenChange={setShowPropertyPopup}
//             >
//               <DialogContent className="max-w-4xl max-h-[80vh] flex flex-col">
//                 {/* Header */}
//                 <DialogHeader>
//                   <DialogTitle>
//                     Select Property for {popupTemplate.name}
//                   </DialogTitle>
//                   <DialogClose />
//                 </DialogHeader>

//                 {/* SCROLLABLE MIDDLE SECTION */}
//                 <div className="flex-1 overflow-y-auto p-6 space-y-4 custom-scrollbar">
//                   {loadingProperties ? (
//                     <p>Loading...</p>
//                   ) : properties.length === 0 ? (
//                     <p>No properties found.</p>
//                   ) : (
//                     properties.map((p) => (
//                       <div
//                         key={p.id}
//                         className="flex items-center justify-between border rounded-lg p-4 hover:shadow-md transition-smooth bg-white"
//                       >
//                         {/* LEFT SIDE: ICON + DETAILS */}
//                         <div className="flex items-start gap-4">
//                           {/* Home Icon */}
//                           <div className="text-primary mt-1">
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               className="h-6 w-6"
//                               fill="none"
//                               viewBox="0 0 24 24"
//                               stroke="currentColor"
//                               strokeWidth={2}
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 d="M3 9.75L12 3l9 6.75M4.5 10.5v9.75a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75V15a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v5.25a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75V10.5"
//                               />
//                             </svg>
//                           </div>

//                           {/* Property Info */}
//                           <div>
//                             <h3 className="text-blue-700 font-semibold hover:underline cursor-pointer">
//                               {p.title || "Unnamed Property"}
//                             </h3>
//                             <div className="flex items-center gap-4 text-sm mt-1">
//                               <span className="text-red-600 font-semibold">
//                                 ${Number(p.price || 0).toLocaleString()}
//                               </span>
//                               <span className="text-muted-foreground">
//                                 🛏 {p.bedrooms} bed
//                               </span>
//                               <span className="text-muted-foreground">
//                                 🛁 {p.bathrooms} bath
//                               </span>
//                               <span className="text-muted-foreground">
//                                 📐 {p.area} sqft
//                               </span>
//                             </div>
//                             <div className="flex items-center gap-2 mt-2">
//                               {p.property_type && (
//                                 <span className="bg-slate-100 text-slate-800 text-xs px-2 py-1 rounded-full font-medium capitalize">
//                                   {p.property_type}
//                                 </span>
//                               )}
//                               {p.status && (
//                                 <span
//                                   className={`text-xs px-2 py-1 rounded-full font-medium capitalize ${
//                                     p.status.toLowerCase() === "active"
//                                       ? "bg-green-100 text-green-700"
//                                       : p.status.toLowerCase() === "inactive"
//                                       ? "bg-gray-100 text-gray-700"
//                                       : p.status.toLowerCase() === "complete"
//                                       ? "bg-blue-100 text-blue-700"
//                                       : "bg-slate-100 text-slate-700"
//                                   }`}
//                                 >
//                                   {p.status}
//                                 </span>
//                               )}
//                             </div>
//                           </div>
//                         </div>

//                         {/* RIGHT SIDE: BUTTON */}
//                         <Button
//                           onClick={() => {
//                             navigate(
//                               `/builder/${popupTemplate.id}?property=${p.id}`
//                             );
//                             setShowPropertyPopup(false);
//                           }}
//                           className="bg-red-500 hover:bg-red-600 text-white font-semibold"
//                         >
//                           Use This Property
//                         </Button>
//                       </div>
//                     ))
//                   )}
//                 </div>

//                 {/* FIXED FOOTER (non-scrolling) */}
//                 <div className="border-t p-4 flex items-center justify-between">
//                   <Button
//                     variant="outline"
//                     onClick={() => navigate("/propertyimport")}
//                   >
//                     <Upload className="mr-2 h-4 w-4" /> Add Property
//                   </Button>
//                   <Button
//                     variant="outline"
//                     onClick={() => setShowPropertyPopup(false)}
//                   >
//                      Cancel
//                   </Button>
//                 </div>
//               </DialogContent>
//             </Dialog>
//           )}
//         </div>
//       </main>
//     </div>
//   );
// };

// export default TemplateGallery;

import React, { useState, useEffect, useRef } from "react";
import { Sidebar } from "@/components/Sidebar";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { useNavigate, Link } from "react-router-dom";
import { Upload, Search, Copy, Star, Layout } from "lucide-react";
import { endpoints } from "@/config/apiEndpoints";
import axiosInstance from "@/config/axiosInstance";
import { useToast } from "@/hooks/use-toast";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from "@/components/ui/dialog";
import Template1 from "@/components/templates/Template1";
import Template2 from "@/components/templates/Template2";
import Template3 from "@/components/templates/Template3";
import Template4 from "@/components/templates/Template4";
import Template5 from "@/components/templates/Template5";
import Template6 from "@/components/templates/Template6";
import Template7 from "@/components/templates/Template7";
import Template8 from "@/components/templates/Template8";
import { PageHeader } from "@/components/Header";

interface Property {
  id: string;
  title: string;
  address: string;
  price: string | number;
  bedrooms: number;
  bathrooms: number;
  area: number;
  property_type: string;
  status: string;
}

interface CustomTemplate {
  id: number;
  name: string;
  html: string;
  design?: string;
  created_at: string;
}

const TemplateGallery = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [properties, setProperties] = useState<Property[]>([]);
  const [loadingProperties, setLoadingProperties] = useState(false);
  const { toast } = useToast();
  const [showPropertyPopup, setShowPropertyPopup] = useState(false);
  const [popupTemplate, setPopupTemplate] = useState<any>(null);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [deleting, setDeleting] = useState(false);
  const [customTemplates, setCustomTemplates] = useState<CustomTemplate[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null); 
  const navigate = useNavigate(); 
  const previewFileInputRef = useRef<HTMLInputElement>(null); 


  const handleTemplateSelect = (template: any) => {
    setPopupTemplate(template);
    setShowPropertyPopup(true);
  };

  const templates = [
    {
      id: 1,
      name: "Template 1",
      category: "Modern Hero Layout",
      style: "Clean & Professional",
      component: Template1,
      rating: 4.8,
      uses: 1247,
      tag: "Just Listed",
    },
    {
      id: 2,
      name: "Template 2",
      category: "Luxury Showcase",
      style: "Premium & Elegant",
      component: Template2,
      rating: 4.9,
      uses: 982,
      tag: "Priced to Sell",
    },
    {
      id: 3,
      name: "Template 3",
      category: "Gallery Focus",
      style: "Image-Driven",
      component: Template3,
      rating: 4.7,
      uses: 756,
      tag: "Open House",
    },
    {
      id: 4,
      name: "Template 4",
      category: "Traditional Layout",
      style: "Classic & Trustworthy",
      component: Template4,
      rating: 4.6,
      uses: 634,
      tag: "Seller Motivated",
    },
    {
      id: 5,
      name: "Template 5",
      category: "Split Screen",
      style: "Modern Balance",
      component: Template5,
      rating: 4.8,
      uses: 523,
      tag: "Just Listed",
    },
    {
      id: 6,
      name: "Template 6",
      category: "Feature-Rich",
      style: "Comprehensive Info",
      component: Template6,
      rating: 4.9,
      uses: 445,
      tag: "Priced to Sell",
    },
    {
      id: 7,
      name: "Template 7",
      category: "Bold Impact",
      style: "Eye-Catching",
      component: Template7,
      rating: 4.7,
      uses: 378,
      tag: "Open House",
    },
    {
      id: 8,
      name: "Template 8",
      category: "Minimalist Pro",
      style: "Simple & Effective",
      component: Template8,
      rating: 4.8,
      uses: 298,
      tag: "Seller Motivated",
    },
  ];

  const filters = [
    { id: "all", label: "All Templates" },
    { id: "modern", label: "Modern" },
    { id: "luxury", label: "Luxury" },
    { id: "traditional", label: "Traditional" },
    { id: "gallery", label: "Gallery Focus" },
  ];

  const filteredTemplates = templates.filter((template) => {
    const matchesSearch =
      template.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      template.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
      template.style.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilter =
      selectedFilter === "all" ||
      template.category.toLowerCase().includes(selectedFilter) ||
      template.style.toLowerCase().includes(selectedFilter);
    return matchesSearch && matchesFilter;
  });

    // Fetch custom templates
  useEffect(() => {
    const fetchCustomTemplates = async () => {
      try {
        const res = await axiosInstance.get(endpoints.custom_templates);
        setCustomTemplates(res.data);
      } catch (error) {
        console.error('Error fetching custom templates:', error);
      }
    };
    fetchCustomTemplates();
  }, []);

  // Delete handler
  const handleDelete = async () => {
    if (!deleteId) return;
    setDeleting(true);
    try {
      await axiosInstance.delete(`${endpoints.custom_templates}${deleteId}/`);
      setCustomTemplates((prev) => prev.filter((t) => t.id !== deleteId));
      toast({ title: 'Deleted', description: 'Template removed.' });
    } catch (err: any) {
      toast({
        title: 'Error',
        description: err.response?.data?.message || 'Failed to delete.',
        variant: 'destructive',
      });
    } finally {
      setDeleting(false);
      setDeleteId(null);
    }
  };

  useEffect(() => {
    if (showPropertyPopup) {
      const fetchProperties = async () => {
        try {
          setLoadingProperties(true);
          const res = await axiosInstance.get(endpoints.properties);
          const sorted = [...res.data].sort((a: any, b: any) => {
            const dateA = new Date(a.created_at || a.id).getTime();
            const dateB = new Date(b.created_at || b.id).getTime();
            return dateB - dateA;
          });
          setProperties(sorted);
        } catch (error) {
          toast({
            title: "Error",
            description: "Failed to load properties",
            variant: "destructive",
          });
        } finally {
          setLoadingProperties(false);
        }
      };
      fetchProperties();
    }
  }, [showPropertyPopup, toast]);

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />

      {/* MAIN STARTS */}
      <main className="flex-1 flex flex-col">
        {/* REUSABLE HEADER */}
        <PageHeader
          title="Real Estate Email Flyer Templates"
          subtitle="Professional, data-driven email flyer templates for property marketing campaigns. Each template auto-fills with your property data and is fully customizable."
          rightButton={
            <Button asChild variant="cta" size="lg">
              <Link to="/template-builder">
                <Layout className="mr-2 h-4 w-4" />
                Create Custom Template
              </Link>
            </Button>
          }
        />

        {/* PAGE CONTENT */}
        <div className="flex-1 p-8 overflow-y-auto">
          <div className="max-w-7xl mx-auto">
            {/* Search and Filters */}
            <div className="mb-8">
              <div className="flex flex-col sm:flex-row gap-4 items-center">
                <div className="relative flex-1 max-w-md">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
                  <Input
                    placeholder="Search templates..."
                    className="pl-10"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>

                <div className="flex flex-wrap gap-2">
                  {filters.map((filter) => (
                    <Button
                      key={filter.id}
                      variant={selectedFilter === filter.id ? "cta" : "outline"}
                      size="sm"
                      onClick={() => setSelectedFilter(filter.id)}
                    >
                      {filter.label}
                    </Button>
                  ))}
                </div>
              </div>
            </div>

            {/* Template Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredTemplates.map((template) => {
                const TemplateComponent = template.component;
                return (
                  <Card
                    key={template.id}
                    className="group cursor-pointer transition-smooth hover:shadow-elevated bg-gradient-card"
                  >
                    <CardContent className="p-0">
                      <div className="relative overflow-hidden rounded-t-lg">
                        <div className="w-full h-48 overflow-hidden bg-white relative">
                          <div className="scale-[0.25] origin-top-left w-[400%] h-[400%] pointer-events-none">
                            <TemplateComponent
                              data={{
                                heroImage: "path_to_image.jpg",
                                headline: "Sample Property",
                                price: 1000000,
                                address: "123 Main St, City, Country",
                                bedrooms: 3,
                                bathrooms: 2,
                                area: 2000,
                                description:
                                  "Beautiful property with modern amenities",
                                text_section: "",
                                list_name: "",
                                features: [
                                  { feature_name: "Pool" },
                                  { feature_name: "Garage" },
                                  { feature_name: "Garden" },
                                ],
                              }}
                              selectedList={""}
                              fileInputRef={previewFileInputRef}
                              onInputChange={() => {}}
                              onFileChange={async () => {}}
                              onAddFeature={() => {}}
                              onFeatureChange={() => {}}
                              onFeatureBlur={() => {}}
                              onFeatureDelete={() => {}}
                              onListChange={async () => {}}
                              propertyLists={[]}
                            />
                          </div>
                        </div>

                        {/* Hover Actions */}
                        <div className="absolute inset-0 bg-primary/20 opacity-0 group-hover:opacity-100 transition-smooth flex items-center justify-center">
                          <div className="flex space-x-2">
                            <Button
                              size="sm"
                              variant="professional"
                              onClick={() => handleTemplateSelect(template)}
                            >
                              <Copy className="mr-2 h-4 w-4" />
                              Use Template
                            </Button>
                          </div>
                        </div>
                      </div>

                      {/* Template Info */}
                      <div className="p-4">
                        <div className="flex justify-between items-start mb-2">
                          <h3 className="font-semibold text-primary group-hover:text-cta transition-smooth">
                            {template.name}
                          </h3>
                          <div className="flex items-center">
                            <Star className="h-4 w-4 fill-current text-yellow-400 mr-1" />
                            <span className="text-sm text-muted-foreground">
                              {template.rating}
                            </span>
                          </div>
                        </div>

                        <div className="flex justify-between items-center">
                          <div className="flex space-x-2">
                            <Badge variant="secondary">
                              {template.category}
                            </Badge>
                            <Badge variant="outline">{template.style}</Badge>
                          </div>
                          <span className="text-xs text-muted-foreground">
                            {template.uses.toLocaleString()} uses
                          </span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>

            {/* Property Selection Dialog */}
            {showPropertyPopup && popupTemplate && (
              <Dialog
                open={showPropertyPopup}
                onOpenChange={setShowPropertyPopup}
              >
                <DialogContent className="max-w-4xl max-h-[80vh] flex flex-col">
                  <DialogHeader>
                    <DialogTitle>
                      Select Property for {popupTemplate.name}
                    </DialogTitle>
                    <DialogClose />
                  </DialogHeader>

                  <div className="flex-1 overflow-y-auto p-6 space-y-4 custom-scrollbar">
                    {loadingProperties ? (
                      <p className="text-center text-muted-foreground">
                        Loading properties...
                      </p>
                    ) : properties.length === 0 ? (
                      <p className="text-center text-muted-foreground">
                        No properties found.
                      </p>
                    ) : (
                      properties.map((p) => (
                        <div
                          key={p.id}
                          className="flex items-center justify-between border rounded-lg p-4 hover:shadow-md transition-smooth bg-white"
                        >
                          <div className="flex items-start gap-4">
                            <div className="text-primary mt-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M3 9.75L12 3l9 6.75M4.5 10.5v9.75a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75V15a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v5.25a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75V10.5"
                                />
                              </svg>
                            </div>

                            <div>
                              <h3 className="text-blue-700 font-semibold hover:underline cursor-pointer">
                                {p.title || "Unnamed Property"}
                              </h3>
                              <div className="flex items-center gap-4 text-sm mt-1">
                                <span className="text-red-600 font-semibold">
                                  ${Number(p.price || 0).toLocaleString()}
                                </span>
                                <span className="text-muted-foreground">
                                  {p.bedrooms} bed
                                </span>
                                <span className="text-muted-foreground">
                                  {p.bathrooms} bath
                                </span>
                                <span className="text-muted-foreground">
                                  {p.area} sqft
                                </span>
                              </div>
                              <div className="flex items-center gap-2 mt-2">
                                {p.property_type && (
                                  <span className="bg-slate-100 text-slate-800 text-xs px-2 py-1 rounded-full font-medium capitalize">
                                    {p.property_type}
                                  </span>
                                )}
                                {p.status && (
                                  <span
                                    className={`text-xs px-2 py-1 rounded-full font-medium capitalize ${
                                      p.status.toLowerCase() === "active"
                                        ? "bg-green-100 text-green-700"
                                        : p.status.toLowerCase() === "inactive"
                                        ? "bg-gray-100 text-gray-700"
                                        : p.status.toLowerCase() === "complete"
                                        ? "bg-blue-100 text-blue-700"
                                        : "bg-slate-100 text-slate-700"
                                    }`}
                                  >
                                    {p.status}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          <Button
                            onClick={() => {
                              navigate(
                                `/builder/${popupTemplate.id}?property=${p.id}`
                              );
                              setShowPropertyPopup(false);
                            }}
                            className="bg-red-500 hover:bg-red-600 text-white font-semibold"
                          >
                            Use This Property
                          </Button>
                        </div>
                      ))
                    )}
                  </div>

                  <div className="border-t p-4 flex items-center justify-between">
                    <Button
                      variant="outline"
                      onClick={() => navigate("/propertyimport")}
                    >
                      <Upload className="mr-2 h-4 w-4" /> Add Property
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => setShowPropertyPopup(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                </DialogContent>
              </Dialog>
            )}
          </div>
        </div>
      </main>
      {/* MAIN ENDS */}
    </div>
  );
};

export default TemplateGallery;
